import React, { useState, useEffect } from "react";
import DocumentoService from "../../../../modules/Documentos/application/DocumentoService";
import { Boton, Spinner } from "asocomponents";
import { useParams } from "react-router-dom";

const VisorAdjuntoThuban = () => {
    const idDocumento = useParams().idDocumento
    const origen = useParams().origen
    const [fileUrl, setFileUrl] = useState(null);
    const [contentType, setContentType] = useState(null);
    const [isLoading, setIsLoading] = useState(false)

    const obtenerDocumento = async () => {
        try {
            setIsLoading(true)
            const documentosServices = new DocumentoService()

            const { blob, contentType } = await (origen==="juicios" ? documentosServices.getDocumentosJuicioPorId(idDocumento) : documentosServices.getDocumentosSiniestroPorId(idDocumento))

            const url = URL.createObjectURL(blob);

            setFileUrl(url)
            setContentType(contentType)
        }
        catch (e) {
            setContentType("")
        }
        finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        obtenerDocumento(idDocumento)
    }, [idDocumento]);

    if (isLoading) {
        return <Spinner color="red" size="50" />
    }

    if (contentType == "") {
        return (
            <div className="flex flex-col justify-center items-center h-full text-center" >
                <b>Este archivo no puede ser visualizado en el navegador<br /></b>
            </div>
        )
    }

    // Render según el tipo de archivo
    if (contentType?.includes("pdf")) {
        return (
            <iframe
                src={fileUrl}
                title="Visor PDF"
                className="w-full h-[600px] border rounded"
            />
        )
    }

    if (contentType?.startsWith("image/")) {
        return <img src={fileUrl} alt="Archivo" className="max-w-full h-auto" />;
    }

    // fallback: descarga
    return (
        <div className="flex flex-col justify-center items-center h-full text-center">
            <b>Este archivo no puede ser visualizado en el navegador<br /></b>
            <Boton texto="Descargar Archivo" onClick={() => {
                const link = document.createElement("a");
                link.href = fileUrl;
                link.download = `${idDocumento}.${contentType?.split("/")[1] || ""}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }} fondo="rojo" />

        </div>
    )
}

export default VisorAdjuntoThuban
